import Icon from '../components/Icon.vue'

Icon.register({
  'file-prescription': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM292.5 315.5L303.8 326.8C310.1 333 310.1 343.2 303.8 349.4L273.9 379.3 304 409.4C310.3 415.6 310.3 425.8 304 432L292.7 443.3C286.4 449.6 276.3 449.6 270.1 443.3L240 413.3 209.9 443.3C203.7 449.6 193.6 449.6 187.3 443.3L176 432C169.8 425.8 169.8 415.6 176 409.4L206.1 379.3 146.7 320H128V368C128 376.8 120.8 384 112 384H96C87.2 384 80 376.8 80 368V208C80 199.2 87.2 192 96 192H176C211.3 192 240 220.7 240 256 240 280.2 226.4 301.1 206.5 311.9L240 345.4 269.9 315.5C276.1 309.2 286.3 309.2 292.5 315.5zM176 272H128V240H176C184.8 240 192 247.2 192 256S184.8 272 176 272zM384 121.9V128H256V0H262.1C268.5 0 274.6 2.5 279.1 7L377 105C381.5 109.5 384 115.6 384 121.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-prescription.js
// module id = SFI6
// module chunks = 144